import { Component } from "react";
import { logError } from "../lib/firebase/logs";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        logError(error, { componentStack: info.componentStack });
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return <h1>Algo inesperado aconteceu.</h1>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;